<script lang="ts">
  // A small info "ⓘ" icon that reveals an explanatory tooltip on hover. The
  // tooltip is position:fixed so it never clips inside overflow containers
  // (e.g. a table's overflow-x-auto). Text wraps; case is normalised so it
  // reads plainly even next to an uppercase eyebrow header.
  let { text, class: cls = '' }: { text: string; class?: string } = $props();

  let open = $state(false);
  let x = $state(0);
  let y = $state(0);

  function enter(e: MouseEvent): void {
    const r = (e.currentTarget as HTMLElement).getBoundingClientRect();
    x = r.left + r.width / 2;
    y = r.top;
    open = true;
  }
</script>

<span
  class="inline-flex cursor-help align-middle text-base-content/58 transition-colors hover:text-base-content/70 {cls}"
  role="presentation"
  onmouseenter={enter}
  onmouseleave={() => (open = false)}
>
  <svg class="h-3.5 w-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
    <circle cx="12" cy="12" r="10" />
    <path d="M12 16v-4M12 8h.01" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</span>

{#if open}
  <span
    class="pointer-events-none fixed z-50 w-52 -translate-x-1/2 -translate-y-full rounded-box border hair bg-base-100 px-2.5 py-2 text-left text-[0.68rem] font-normal normal-case leading-snug tracking-normal text-base-content/75 shadow-xl"
    style="left:{x}px; top:{y - 6}px;"
    role="tooltip"
  >
    {text}
  </span>
{/if}
